import { render } from "./OrderItem.vue?vue&type=template&id=c644ba38&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=c644ba38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c644ba38"

export default script